import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Lock } from 'lucide-react';
import { base44 } from '@/api/base44Client';
import { useQuery } from '@tanstack/react-query';

import ProjectsManager from '../components/admin/ProjectsManager';
import StudioManager from '../components/admin/StudioManager';
import TestimonialsManager from '../components/admin/TestimonialsManager';
import CategoriesManager from '../components/admin/CategoriesManager';
import MaintenanceToggle from '../components/admin/MaintenanceToggle';
import HomeManager from '../components/admin/HomeManager';

export default function Gestione() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    const checkAuth = async () => {
      try {
        const currentUser = await base44.auth.me();
        if (currentUser?.role !== 'admin') {
          setUser(null);
        } else {
          setUser(currentUser);
        }
      } catch (error) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-[#7a7a7a]">Caricamento...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8f8f8]">
        <Card className="w-full max-w-md mx-4">
          <CardContent className="pt-6 text-center">
            <Lock className="w-12 h-12 mx-auto mb-4 text-[#9c8b7a]" />
            <h2 className="text-xl font-serif mb-2">Accesso Riservato</h2>
            <p className="text-[#7a7a7a] mb-6">
              Questa pagina è accessibile solo agli amministratori.
            </p>
            <button
              onClick={() => base44.auth.redirectToLogin(window.location.pathname)}
              className="bg-[#9c8b7a] hover:bg-[#8a7a6a] text-white text-sm px-6 py-2 rounded transition-colors"
            >
              Accedi
            </button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="pt-24 pb-20 bg-[#f8f8f8] min-h-screen">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <h1 className="text-3xl md:text-4xl font-serif font-light text-[#2d2d2d] mb-8">
          Pannello di Gestione
        </h1>

        <div className="mb-8">
          <MaintenanceToggle />
        </div>

        <Tabs defaultValue="projects" className="w-full">
          <TabsList className="mb-8">
            <TabsTrigger value="projects">Progetti</TabsTrigger>
            <TabsTrigger value="home">Home</TabsTrigger>
            <TabsTrigger value="studio">Studio</TabsTrigger>
            <TabsTrigger value="testimonials">Press</TabsTrigger>
            <TabsTrigger value="categories">Categorie Home</TabsTrigger>
          </TabsList>

          <TabsContent value="projects">
            <ProjectsManager />
          </TabsContent>

          <TabsContent value="home">
            <HomeManager />
          </TabsContent>

          <TabsContent value="studio">
            <StudioManager />
          </TabsContent>

          <TabsContent value="testimonials">
            <TestimonialsManager />
          </TabsContent>

          <TabsContent value="categories">
            <CategoriesManager />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}